export class Configuration {

    public authenticationEndpoint: string;
    public authenticationLoginRedirectUri: string;
    public authenticationLogoutRedirectUri: string;
    public authenticationClientId: string;

    public reportConfigurationServiceUri: string;
    public reportConfigurationAPIEndpoint: string;

    public appInsightsInstrumentationKey: string;

    constructor(base?: Configuration) {
        if (base != null) {
            this.authenticationEndpoint = base.authenticationEndpoint;
            this.authenticationLoginRedirectUri = base.authenticationLoginRedirectUri;
            this.authenticationLogoutRedirectUri = base.authenticationLogoutRedirectUri;
            this.authenticationClientId = base.authenticationClientId;

            this.appInsightsInstrumentationKey = base.appInsightsInstrumentationKey;

            this.reportConfigurationServiceUri = base.reportConfigurationServiceUri;
            this.reportConfigurationAPIEndpoint = base.reportConfigurationAPIEndpoint;
        }
    }

    /**
     * Return a "raw" enpoint, without the '/api' bit that our (old) services need.
     */
    public get reportConfigurationServiceEndpoint(): string {
        return this.reportConfigurationAPIEndpoint.substring(0, this.reportConfigurationAPIEndpoint.length - 4);
    }

}